import { useState, useEffect } from 'react';
import axios from 'axios';

interface ValidationJSONRecordsResponse {
  json_data?: unknown[];
}

export const useDataValidationFileValidationData = (
  owner?: string,
  validation_id?: string | null
) => {
  const [data, setData] = useState<unknown[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!owner || !validation_id) {
        setData([]);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const response = await axios.get<ValidationJSONRecordsResponse>(
          '/api/v1/validation/data_validation_file_validation_data',
          {
            params: {
              owner,
              validation_id,
            },
          }
        );

        setData(response.data.json_data || []);
      } catch (err) {
        setError(
          err instanceof Error
            ? err
            : new Error('Failed to fetch validation data')
        );
        console.error('Error fetching validation data:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [owner, validation_id]);

  // Return a loadable-like object to maintain compatibility
  return {
    state: loading ? 'loading' : error ? 'hasError' : 'hasValue',
    contents: data,
    getValue: () => data,
    valueMaybe: () => (loading ? undefined : data),
    toPromise: () => Promise.resolve(data),
    errorMessage: error?.message,
  };
};
